/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  LiquidityBootstrapAuction,
  LiquidityBootstrapAuctionInterface,
} from "../LiquidityBootstrapAuction";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "multisig",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "_asto",
        type: "address",
      },
      {
        internalType: "contract IERC20",
        name: "_usdc",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "rewardAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "startTime",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDepositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDepositedUSDC",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedUSDC",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct LiquidityBootstrapAuction.Stats",
        name: "stats",
        type: "tuple",
      },
    ],
    name: "ASTODeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "astoAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "usdcAmount",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "lpTokenAmount",
        type: "uint256",
      },
    ],
    name: "LiquidityAdded",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RewardsClaimed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenAmount",
        type: "uint256",
      },
    ],
    name: "TokenWithdrawn",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDepositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDepositedUSDC",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedUSDC",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct LiquidityBootstrapAuction.Stats",
        name: "stats",
        type: "tuple",
      },
    ],
    name: "USDCDeposited",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDepositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDepositedUSDC",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedUSDC",
            type: "uint256",
          },
        ],
        indexed: false,
        internalType: "struct LiquidityBootstrapAuction.Stats",
        name: "stats",
        type: "tuple",
      },
    ],
    name: "USDCWithdrawn",
    type: "event",
  },
  {
    inputs: [],
    name: "HOURS_PER_DAY",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REWARDS_RELEASE_DURATION_IN_WEEKS",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SECONDS_PER_DAY",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "SECONDS_PER_HOUR",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "router",
        type: "address",
      },
      {
        internalType: "address",
        name: "factory",
        type: "address",
      },
    ],
    name: "addLiquidityToExchange",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "asto",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "astoDepositAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "astoDepositEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "astoRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "auctionEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "auctionStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "calculateASTORewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "calculateRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "calculateUSDCRewards",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "claimLPToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "claimRewards",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "claimableLPAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "claimableRewards",
    outputs: [
      {
        internalType: "uint16",
        name: "",
        type: "uint16",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "astoAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "usdcAmount",
        type: "uint256",
      },
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "depositASTO",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "depositUSDC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositedASTO",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "depositedUSDC",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "liquidityPair",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "lpClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lpTokenAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lpTokenReleaseTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "rewardClaimed",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "newStartTime",
        type: "uint256",
      },
    ],
    name: "setStartTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "depositor",
        type: "address",
      },
    ],
    name: "stats",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "totalDepositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "totalDepositedUSDC",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedASTO",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "depositedUSDC",
            type: "uint256",
          },
        ],
        internalType: "struct LiquidityBootstrapAuction.Stats",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "timeline",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "auctionStartTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "astoDepositEndTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "usdcDepositEndTime",
            type: "uint256",
          },
          {
            internalType: "uint256",
            name: "auctionEndTime",
            type: "uint256",
          },
        ],
        internalType: "struct LiquidityBootstrapAuction.Timeline",
        name: "",
        type: "tuple",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDepositedASTO",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalDepositedUSDC",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "usdc",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcDepositAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcDepositEndTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcRewardAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcWithdrawAllowed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "usdcWithdrawLastDay",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "usdcWithdrawnOnDay6",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "usdcWithdrawnOnDay7",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "token",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawToken",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "withdrawUSDC",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
    ],
    name: "withdrawableUSDCAmount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60e06040523480156200001157600080fd5b506040516200309c3803806200309c833981016040819052620000349162000184565b6001600055620000443362000132565b6001600160a01b038416620000a05760405162461bcd60e51b815260206004820152601560248201527f696e76616c696420746f6b656e2061646472657373000000000000000000000060448201526064015b60405180910390fd5b6001600160a01b038316620000f85760405162461bcd60e51b815260206004820152601560248201527f696e76616c696420746f6b656e20616464726573730000000000000000000000604482015260640162000097565b6001600160601b0319606085811b821660805284901b1660a05260c08290526002819055620001278562000132565b505050505062000202565b600180546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b600080600080600060a086880312156200019d57600080fd5b8551620001aa81620001e9565b6020870151909550620001bd81620001e9565b6040870151909450620001d081620001e9565b6060870151608090970151959894975095949392505050565b6001600160a01b0381168114620001ff57600080fd5b50565b60805160601c60a05160601c60c051612dbc620002e0600039600081816104c6015281816116f401526117a301526000818161036601528181610b2901528181610c5e01528181610d60015281816110d4015281816111600152818161130a0152818161133101528181611f490152818161219501526122e901526000818161062e015281816107400152818161081d01528181610bcd01528181610c7f01528181610d3801528181610e6f015281816110b301528181611181015281816112e401528181611357015281816119c20152611b160152612dbc6000f3fe608060405234801561001057600080fd5b50600436106102bb5760003560e01c80638bcdcbf311610182578063d0b52ed7116100e9578063e7f1c3af116100a2578063f2e5ca831161007c578063f2e5ca8314610629578063f2fde38b14610650578063f35eb79614610663578063f688bcfb1461066c57600080fd5b8063e7f1c3af146105f8578063eb54f9ec14610618578063efae49191461062157600080fd5b8063d0b52ed714610577578063d18e81b31461057f578063d5ac132e14610585578063db81f99b146105a5578063dc01f60d146105b8578063e2bbb158146105e557600080fd5b8063a22d29e41161013b578063a22d29e414610503578063ac67658514610523578063aca2db5c14610536578063b35adc1a14610549578063b6d3cce714610551578063c077ca791461056457600080fd5b80638bcdcbf3146104825780638c2ee01b146104955780638da5cb5b146104b05780638e73064f146104c1578063949fa9d2146104e85780639e281a98146104f057600080fd5b80634df8612611610226578063808a5457116101df578063808a54571461042157806380a36517146104345780638384a3951461043c578063847e27081461044f57806385a428d1146104575780638b9b056b1461047a57600080fd5b80634df86126146103b857806358122141146103c157806364ab8675146103d9578063704c73dc146103ec578063715018a61461040f57806374f0314f1461041757600080fd5b806336acbe6b1161027857806336acbe6b146103455780633e0a322d1461034e5780633e413bee1461036157806348aabb51146103a05780634b449cba146103a85780634ca50eb2146103b057600080fd5b80630962ef79146102c05780630bc3b1c0146102d5578063131b5abd146102dd57806317a5410b146102f057806327175b231461030e57806329e1970414610325575b600080fd5b6102d36102ce366004612a71565b61067f565b005b6102d3610882565b6102d36102eb3660046128d5565b6109f8565b6102f86114d9565b6040516103059190612bc2565b60405180910390f35b61031760035481565b604051908152602001610305565b61031761033336600461289b565b600b6020526000908152604090205481565b61031760065481565b6102d361035c366004612a71565b611540565b6103887f000000000000000000000000000000000000000000000000000000000000000081565b6040516001600160a01b039091168152602001610305565b61031761154d565b610317611565565b610317611578565b610317610e1081565b6103c961158b565b6040519015158152602001610305565b6103176103e736600461289b565b6115af565b6103c96103fa36600461289b565b600a6020526000908152604090205460ff1681565b6102d36115d3565b6103176201518081565b600554610388906001600160a01b031681565b6103176115e7565b61031761044a36600461289b565b6115fa565b6103176116d4565b6103c961046536600461289b565b60096020526000908152604090205460ff1681565b6103176116eb565b6102f861049036600461289b565b611724565b61049d601881565b60405161ffff9091168152602001610305565b6001546001600160a01b0316610388565b6103177f000000000000000000000000000000000000000000000000000000000000000081565b61031761179a565b6102d36104fe36600461290e565b6117c9565b61031761051136600461289b565b600c6020526000908152604090205481565b6102d3610531366004612a71565b611939565b61031761054436600461289b565b611b3e565b61049d600c81565b61031761055f36600461289b565b611b8b565b61031761057236600461289b565b611cf5565b6103c9611d2e565b42610317565b61031761059336600461289b565b60086020526000908152604090205481565b6102d36105b3366004612a71565b611d4b565b6105cb6105c636600461289b565b611f70565b6040805161ffff9093168352602083019190915201610305565b6102d36105f3366004612aa3565b612054565b61031761060636600461289b565b60076020526000908152604090205481565b61031760025481565b6103c9612076565b6103887f000000000000000000000000000000000000000000000000000000000000000081565b6102d361065e36600461289b565b612093565b61031760045481565b6102d361067a366004612a71565b61210c565b600260005414156106ab5760405162461bcd60e51b81526004016106a290612b8b565b60405180910390fd5b600260009081556106bb33611f70565b915050808211156107055760405162461bcd60e51b8152602060048201526014602482015273616d6f756e74206e6f7420636c61696d61626c6560601b60448201526064016106a2565b336000908152600b602052604081208054849290610724908490612c93565b90915550506040516370a0823160e01b815230600482015282907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906370a082319060240160206040518083038186803b15801561078a57600080fd5b505afa15801561079e573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906107c29190612a8a565b10156108105760405162461bcd60e51b815260206004820152601960248201527f696e73756666696369656e74204153544f2062616c616e63650000000000000060448201526064016106a2565b6108446001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000163384612311565b60405182815233907ffc30cddea38e2bf4d6ea7d3f9ed3b6ad7f176419f4963bd81318067a4aee73fe9060200160405180910390a250506001600055565b600260005414156108a55760405162461bcd60e51b81526004016106a290612b8b565b600260009081556108b5336115fa565b9050600081116108fc5760405162461bcd60e51b815260206004820152601260248201527137379031b630b4b6b0b13632903a37b5b2b760711b60448201526064016106a2565b336000908152600c60205260408120805483929061091b908490612c93565b909155505060055460405163a9059cbb60e01b8152336004820152602481018390526001600160a01b039091169063a9059cbb90604401602060405180830381600087803b15801561096c57600080fd5b505af1158015610980573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906109a491906129ff565b6109f05760405162461bcd60e51b815260206004820152601d60248201527f696e73756666696369656e74204c5020746f6b656e2062616c616e636500000060448201526064016106a2565b506001600055565b60026000541415610a1b5760405162461bcd60e51b81526004016106a290612b8b565b6002600055610a28612379565b610a30611565565b421015610a765760405162461bcd60e51b8152602060048201526014602482015273185d58dd1a5bdb881b9bdd08199a5b9a5cda195960621b60448201526064016106a2565b600060035411610abc5760405162461bcd60e51b81526020600482015260116024820152701b9bc81554d110c819195c1bdcda5d1959607a1b60448201526064016106a2565b600060045411610b025760405162461bcd60e51b81526020600482015260116024820152701b9bc81054d513c819195c1bdcda5d1959607a1b60448201526064016106a2565b60405163095ea7b360e01b81526001600160a01b03838116600483015260001960248301527f0000000000000000000000000000000000000000000000000000000000000000169063095ea7b390604401602060405180830381600087803b158015610b6d57600080fd5b505af1158015610b81573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610ba591906129ff565b5060405163095ea7b360e01b81526001600160a01b03838116600483015260001960248301527f0000000000000000000000000000000000000000000000000000000000000000169063095ea7b390604401602060405180830381600087803b158015610c1157600080fd5b505af1158015610c25573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610c4991906129ff565b50600080836001600160a01b031663e8e337007f00000000000000000000000000000000000000000000000000000000000000007f000000000000000000000000000000000000000000000000000000000000000060035460045460008030426040518963ffffffff1660e01b8152600401610ccc989796959493929190612b0f565b606060405180830381600087803b158015610ce657600080fd5b505af1158015610cfa573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610d1e9190612ac5565b60065560405163e6a4390560e01b81526001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000811660048301527f0000000000000000000000000000000000000000000000000000000000000000811660248301529294509092509084169063e6a439059060440160206040518083038186803b158015610db157600080fd5b505afa158015610dc5573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610de991906128b8565b600580546001600160a01b0319166001600160a01b039290921691909117905560035482148015610e1b575060045481145b15610e6a57600654604080518381526020810185905280820192909252517fd7f28048575eead8851d024ead087913957dfb4fd1a02b4d1573f5352a5a2be39181900360600190a150506114d0565b6000807f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316600560009054906101000a90046001600160a01b03166001600160a01b0316630dfe16816040518163ffffffff1660e01b815260040160206040518083038186803b158015610ee557600080fd5b505afa158015610ef9573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610f1d91906128b8565b6001600160a01b03161415610fc857600560009054906101000a90046001600160a01b03166001600160a01b0316630902f1ac6040518163ffffffff1660e01b815260040160606040518083038186803b158015610f7a57600080fd5b505afa158015610f8e573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610fb29190612a21565b506001600160701b039182169350169050611060565b600560009054906101000a90046001600160a01b03166001600160a01b0316630902f1ac6040518163ffffffff1660e01b815260040160606040518083038186803b15801561101657600080fd5b505afa15801561102a573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061104e9190612a21565b506001600160701b0390811693501690505b6040805160028082526060820183526000928392919060208301908036833701905050905060008060035488141561113f57866004546110a09190612cec565b90506110af81600088886123d3565b93507f00000000000000000000000000000000000000000000000000000000000000007f00000000000000000000000000000000000000000000000000000000000000008460008151811061110657611106612d45565b602002602001018560018151811061112057611120612d45565b6001600160a01b039384166020918202929092010152911690526111ec565b8760035461114d9190612cec565b905061115c81600087896123d3565b93507f00000000000000000000000000000000000000000000000000000000000000007f0000000000000000000000000000000000000000000000000000000000000000846000815181106111b3576111b3612d45565b60200260200101856001815181106111cd576111cd612d45565b6001600160a01b03938416602091820292909201015291169052600191505b6000841161123c5760405162461bcd60e51b815260206004820152601960248201527f73776170416d74206d757374206772656174207468656e20300000000000000060448201526064016106a2565b6040516338ed173960e01b81526000906001600160a01b038c16906338ed1739906112739088908590899030904290600401612bed565b600060405180830381600087803b15801561128d57600080fd5b505af11580156112a1573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f191682016040526112c9919081019061293a565b90506000808c6001600160a01b031663e8e3370086611308577f000000000000000000000000000000000000000000000000000000000000000061132a565b7f00000000000000000000000000000000000000000000000000000000000000005b87611355577f0000000000000000000000000000000000000000000000000000000000000000611377565b7f00000000000000000000000000000000000000000000000000000000000000005b6113818b89612cec565b8760018151811061139457611394612d45565b602002602001015160008030426040518963ffffffff1660e01b81526004016113c4989796959493929190612b0f565b606060405180830381600087803b1580156113de57600080fd5b505af11580156113f2573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906114169190612ac5565b9250509150806006600082825461142d9190612c93565b9091555060009050856114545782611445898d612c93565b61144f9190612c93565b611456565b8a5b9050600086611465578c61147a565b836114708a8f612c93565b61147a9190612c93565b6006546040805185815260208101849052908101919091529091507fd7f28048575eead8851d024ead087913957dfb4fd1a02b4d1573f5352a5a2be39060600160405180910390a1505050505050505050505050505b50506001600055565b6115046040518060800160405280600081526020016000815260200160008152602001600081525090565b6040518060800160405280600254815260200161151f61154d565b815260200161152c6115e7565b8152602001611539611565565b9052919050565b611548612379565b600255565b60006002546203f4806115609190612c93565b905090565b600060025462093a806115609190612c93565b60006002546207e9006115609190612c93565b60006002546115974290565b1015801561156057506115a8611565565b4210905090565b60006115ba82611cf5565b6115c383611b3e565b6115cd9190612c93565b92915050565b6115db612379565b6115e560006124fa565b565b6000600254620697806115609190612c93565b60006116046116d4565b42101561161357506000919050565b600060045460026116249190612ccd565b6001600160a01b03841660009081526008602052604090205460065461164a9190612ccd565b6116549190612cab565b9050600060035460026116679190612ccd565b6001600160a01b03851660009081526007602052604090205460065461168d9190612ccd565b6116979190612cab565b905060006116a58284612c93565b6001600160a01b0386166000908152600c60205260409020549091506116cb9082612cec565b95945050505050565b60006116de611565565b61156090626ebe00612c93565b6000606461171a7f00000000000000000000000000000000000000000000000000000000000000006019612ccd565b6115609190612cab565b61174f6040518060800160405280600081526020016000815260200160008152602001600081525090565b506040805160808101825260045481526003546020808301919091526001600160a01b0390931660008181526008855283812054838501529081526007909352912054606082015290565b6000606461171a7f0000000000000000000000000000000000000000000000000000000000000000604b612ccd565b6117d1612379565b6001600160a01b03821661181f5760405162461bcd60e51b8152602060048201526015602482015274696e76616c696420746f6b656e206164647265737360581b60448201526064016106a2565b6040516370a0823160e01b81523060048201526000906001600160a01b038416906370a082319060240160206040518083038186803b15801561186157600080fd5b505afa158015611875573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906118999190612a8a565b9050808211156118eb5760405162461bcd60e51b815260206004820181905260248201527f616d6f756e742073686f756c64206e6f74206578636565642062616c616e636560448201526064016106a2565b6118ff6001600160a01b0384163384612311565b60405182815233907fa2bd9fcfcdba69f52bcd9a520846ad4bd685b187483f53efc42d035b2ddebff09060200160405180910390a2505050565b6002600054141561195c5760405162461bcd60e51b81526004016106a290612b8b565b6002600055611969612076565b6119ab5760405162461bcd60e51b815260206004820152601360248201527219195c1bdcda5d081b9bdd08185b1b1bddd959606a1b60448201526064016106a2565b6040516370a0823160e01b815233600482015281907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906370a082319060240160206040518083038186803b158015611a0c57600080fd5b505afa158015611a20573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190611a449190612a8a565b1015611a895760405162461bcd60e51b8152602060048201526014602482015273696e73756666696369656e742062616c616e636560601b60448201526064016106a2565b3360009081526008602052604081208054839290611aa8908490612c93565b925050819055508060046000828254611ac19190612c93565b909155503390507f60fee21186b3c4e83db2c74db319f6c4761d9dec6c40bedcb066de2ac5e4eada82611af383611724565b604051611b01929190612c5e565b60405180910390a26109f06001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001633308461254c565b600060045460001415611b5357506000919050565b6004546001600160a01b038316600090815260086020526040902054611b7761179a565b611b819190612ccd565b6115cd9190612cab565b6000600254611b974290565b1080611baa5750611ba6611565565b4210155b15611bb757506000919050565b611bbf6115e7565b421015611be257506001600160a01b031660009081526007602052604090205490565b611bea611578565b4210611cac576001600160a01b0382166000908152600a602052604090205460ff1615611c1957506000919050565b6000611c23611578565b611c2d9042612cec565b6001600160a01b03841660009081526007602052604081205491925090611c5690600290612cab565b905062015180821115611c6d575060009392505050565b6000610e10611c7f8462015180612cec565b611c899190612cab565b611c94906001612c93565b90506018611ca28284612ccd565b6116cb9190612cab565b6001600160a01b03821660009081526009602052604090205460ff16611ced5733600090815260076020526040902054611ce890600290612cab565b6115cd565b600092915050565b600060035460001415611d0a57506000919050565b6003546001600160a01b038316600090815260076020526040902054611b776116eb565b6000600254611d3a4290565b1015801561156057506115a86115e7565b60026000541415611d6e5760405162461bcd60e51b81526004016106a290612b8b565b6002600055611d7b61158b565b611dbe5760405162461bcd60e51b81526020600482015260146024820152731dda5d1a191c985dc81b9bdd08185b1b1bddd95960621b60448201526064016106a2565b60008111611e0e5760405162461bcd60e51b815260206004820152601f60248201527f616d6f756e742073686f756c642067726561746572207468616e207a65726f0060448201526064016106a2565b611e1733611b8b565b811115611e665760405162461bcd60e51b815260206004820152601960248201527f616d6f756e7420657863656564656420616c6c6f77616e63650000000000000060448201526064016106a2565b611e6e611578565b4210611e9357336000908152600a60205260409020805460ff19166001179055611ebc565b611e9b6115e7565b4210611ebc57336000908152600960205260409020805460ff191660011790555b3360009081526007602052604081208054839290611edb908490612cec565b925050819055508060036000828254611ef49190612cec565b909155503390507f6f1035fb0123f98a95974d9624cec6ad2bd47c282e28df0162d1feb83c87056682611f2683611724565b604051611f34929190612c5e565b60405180910390a26109f06001600160a01b037f0000000000000000000000000000000000000000000000000000000000000000163383612311565b600080611f7b611565565b421015611f8d57506000928392509050565b6000611f97611565565b611fa19042612cec565b90506000611fb262093a8083612cab565b9050600c61ffff821610611ffa576001600160a01b0385166000908152600b6020526040812054611fe2876115af565b611fec9190612cec565b600c97909650945050505050565b6000600c612007876115af565b6120119190612cab565b6001600160a01b0387166000908152600b60205260408120549192509061203c61ffff851684612ccd565b6120469190612cec565b929792965091945050505050565b81156120635761206382611939565b8015612072576120728161210c565b5050565b60006002546120824290565b1015801561156057506115a861154d565b61209b612379565b6001600160a01b0381166121005760405162461bcd60e51b815260206004820152602660248201527f4f776e61626c653a206e6577206f776e657220697320746865207a65726f206160448201526564647265737360d01b60648201526084016106a2565b612109816124fa565b50565b6002600054141561212f5760405162461bcd60e51b81526004016106a290612b8b565b600260005561213c611d2e565b61217e5760405162461bcd60e51b815260206004820152601360248201527219195c1bdcda5d081b9bdd08185b1b1bddd959606a1b60448201526064016106a2565b6040516370a0823160e01b815233600482015281907f00000000000000000000000000000000000000000000000000000000000000006001600160a01b0316906370a082319060240160206040518083038186803b1580156121df57600080fd5b505afa1580156121f3573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906122179190612a8a565b101561225c5760405162461bcd60e51b8152602060048201526014602482015273696e73756666696369656e742062616c616e636560601b60448201526064016106a2565b336000908152600760205260408120805483929061227b908490612c93565b9250508190555080600360008282546122949190612c93565b909155503390507f0c425e10f92bc0e7d1a626a827a5620f20cf26ab3e9763fca37ed442ff3d21f9826122c683611724565b6040516122d4929190612c5e565b60405180910390a26109f06001600160a01b037f00000000000000000000000000000000000000000000000000000000000000001633308461254c565b6040516001600160a01b03831660248201526044810182905261237490849063a9059cbb60e01b906064015b60408051601f198184030181529190526020810180516001600160e01b03166001600160e01b03199093169290921790915261258a565b505050565b6001546001600160a01b031633146115e55760405162461bcd60e51b815260206004820181905260248201527f4f776e61626c653a2063616c6c6572206973206e6f7420746865206f776e657260448201526064016106a2565b60006123df848461265c565b6123e9868461265c565b101561242e5760405162461bcd60e51b81526020600482015260146024820152731a5b9d985b1a59081d1bdad95b88185b5bdd5b9d60621b60448201526064016106a2565b6103e5600061243f6107cd8661265c565b90506000612460612450888861265c565b61245a8a8861265c565b9061266f565b9050600061248d876124876124758b8a61267b565b612481866103e861265c565b90612687565b9061265c565b905060006124a06004612487878561265c565b905060006124c06124bb836124b5888061265c565b9061267b565b612693565b905060006124ce828761266f565b905060006124dd88600261265c565b90506124e98282612687565b9d9c50505050505050505050505050565b600180546001600160a01b038381166001600160a01b0319831681179093556040519116919082907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6040516001600160a01b03808516602483015283166044820152606481018290526125849085906323b872dd60e01b9060840161233d565b50505050565b60006125df826040518060400160405280602081526020017f5361666545524332303a206c6f772d6c6576656c2063616c6c206661696c6564815250856001600160a01b03166127039092919063ffffffff16565b80519091501561237457808060200190518101906125fd91906129ff565b6123745760405162461bcd60e51b815260206004820152602a60248201527f5361666545524332303a204552433230206f7065726174696f6e20646964206e6044820152691bdd081cdd58d8d9595960b21b60648201526084016106a2565b60006126688284612ccd565b9392505050565b60006126688284612cec565b60006126688284612c93565b60006126688284612cab565b600060038211156126f457508060006126ad600283612cab565b6126b8906001612c93565b90505b818110156126ee579050806002816126d38186612cab565b6126dd9190612c93565b6126e79190612cab565b90506126bb565b50919050565b81156126fe575060015b919050565b6060612712848460008561271a565b949350505050565b60608247101561277b5760405162461bcd60e51b815260206004820152602660248201527f416464726573733a20696e73756666696369656e742062616c616e636520666f6044820152651c8818d85b1b60d21b60648201526084016106a2565b6001600160a01b0385163b6127d25760405162461bcd60e51b815260206004820152601d60248201527f416464726573733a2063616c6c20746f206e6f6e2d636f6e747261637400000060448201526064016106a2565b600080866001600160a01b031685876040516127ee9190612af3565b60006040518083038185875af1925050503d806000811461282b576040519150601f19603f3d011682016040523d82523d6000602084013e612830565b606091505b509150915061284082828661284b565b979650505050505050565b6060831561285a575081612668565b82511561286a5782518084602001fd5b8160405162461bcd60e51b81526004016106a29190612b58565b80516001600160701b03811681146126fe57600080fd5b6000602082840312156128ad57600080fd5b813561266881612d71565b6000602082840312156128ca57600080fd5b815161266881612d71565b600080604083850312156128e857600080fd5b82356128f381612d71565b9150602083013561290381612d71565b809150509250929050565b6000806040838503121561292157600080fd5b823561292c81612d71565b946020939093013593505050565b6000602080838503121561294d57600080fd5b825167ffffffffffffffff8082111561296557600080fd5b818501915085601f83011261297957600080fd5b81518181111561298b5761298b612d5b565b8060051b604051601f19603f830116810181811085821117156129b0576129b0612d5b565b604052828152858101935084860182860187018a10156129cf57600080fd5b600095505b838610156129f25780518552600195909501949386019386016129d4565b5098975050505050505050565b600060208284031215612a1157600080fd5b8151801515811461266857600080fd5b600080600060608486031215612a3657600080fd5b612a3f84612884565b9250612a4d60208501612884565b9150604084015163ffffffff81168114612a6657600080fd5b809150509250925092565b600060208284031215612a8357600080fd5b5035919050565b600060208284031215612a9c57600080fd5b5051919050565b60008060408385031215612ab657600080fd5b50508035926020909101359150565b600080600060608486031215612ada57600080fd5b8351925060208401519150604084015190509250925092565b60008251612b05818460208701612d03565b9190910192915050565b6001600160a01b039889168152968816602088015260408701959095526060860193909352608085019190915260a084015290921660c082015260e08101919091526101000190565b6020815260008251806020840152612b77816040850160208701612d03565b601f01601f19169190910160400192915050565b6020808252601f908201527f5265656e7472616e637947756172643a207265656e7472616e742063616c6c00604082015260600190565b81518152602080830151908201526040808301519082015260608083015190820152608081016115cd565b600060a082018783526020878185015260a0604085015281875180845260c086019150828901935060005b81811015612c3d5784516001600160a01b031683529383019391830191600101612c18565b50506001600160a01b03969096166060850152505050608001529392505050565b82815260a081016126686020830184805182526020810151602083015260408101516040830152606081015160608301525050565b60008219821115612ca657612ca6612d2f565b500190565b600082612cc857634e487b7160e01b600052601260045260246000fd5b500490565b6000816000190483118215151615612ce757612ce7612d2f565b500290565b600082821015612cfe57612cfe612d2f565b500390565b60005b83811015612d1e578181015183820152602001612d06565b838111156125845750506000910152565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052603260045260246000fd5b634e487b7160e01b600052604160045260246000fd5b6001600160a01b038116811461210957600080fdfea2646970667358221220329d6cd3523db9168114b2d2b282576310a0e1e629e8d33a519682d2d0b1c66164736f6c63430008060033";

export class LiquidityBootstrapAuction__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    multisig: string,
    _asto: string,
    _usdc: string,
    rewardAmount: BigNumberish,
    startTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<LiquidityBootstrapAuction> {
    return super.deploy(
      multisig,
      _asto,
      _usdc,
      rewardAmount,
      startTime,
      overrides || {}
    ) as Promise<LiquidityBootstrapAuction>;
  }
  getDeployTransaction(
    multisig: string,
    _asto: string,
    _usdc: string,
    rewardAmount: BigNumberish,
    startTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      multisig,
      _asto,
      _usdc,
      rewardAmount,
      startTime,
      overrides || {}
    );
  }
  attach(address: string): LiquidityBootstrapAuction {
    return super.attach(address) as LiquidityBootstrapAuction;
  }
  connect(signer: Signer): LiquidityBootstrapAuction__factory {
    return super.connect(signer) as LiquidityBootstrapAuction__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): LiquidityBootstrapAuctionInterface {
    return new utils.Interface(_abi) as LiquidityBootstrapAuctionInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): LiquidityBootstrapAuction {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as LiquidityBootstrapAuction;
  }
}
